import { render } from "./Footer.vue?vue&type=template&id=1122a5d8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=1122a5d8&lang=scss&scoped=true"

import exportComponent from "/home/cosmic/citadel-website/citadel-landing-dao-version-citadelone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1122a5d8"]])

export default __exports__